import { Button, Divider, Modal } from "antd";
import React from "react";
import { MapContainer, TileLayer, GeoJSON } from "react-leaflet";
import { useDispatch, useSelector } from "react-redux";
import { selectLicenseList, setPotentialModal } from "../../api/redux";

export default () => {
  const state = useSelector(selectLicenseList);

  const dispatch = useDispatch();
  const onClose = () => {
    dispatch(setPotentialModal(false));
  };
  return (
    <Modal
      title={`پتانسیل سرمایه گذاری:‌ ${state.currentPotential?.title}`}
      className="as-modal d-flex-column text-right p-5"
      footer={false}
      width={"75%"}
      visible={state.potentialModal}
      onCancel={onClose}
    >
      <div className="d-flex flex-wrap">
        <div className="col-12">
          {" "}
          <span style={{ color: "#6c6c6c", fontSize: "15px" }}>عنوان</span>{" "}
          <br />
          <h5 className="mt-2">{state.currentPotential?.title}</h5>
        </div>
        <Divider className="col-12" />

        {state.currentPotential?.Sector && (
          <h6 className="col-md-4 col-12 my-1">
            <span style={{ color: "#6c6c6c", fontSize: "15px" }}>
              بخش سرمایه گذاری
            </span>{" "}
            <br />
            <h5 className="mt-1">{state.currentPotential?.Sector.title}</h5>
          </h6>
        )}
        {state.currentPotential?.SubSector && (
          <h6 className="col-md-4 col-12 my-1">
            <span style={{ color: "#6c6c6c", fontSize: "15px" }}>
              زیربخش سرمایه گذاری
            </span>{" "}
            <br />
            <h5 className="mt-1">{state.currentPotential?.SubSector.title}</h5>
          </h6>
        )}
        {state.currentPotential?.Organization && (
          <h6 className="col-md-4 col-12 my-1">
            <span style={{ color: "#6c6c6c", fontSize: "15px" }}>سازمان</span>{" "}
            <br />
            <h5 className="mt-1">
              {state.currentPotential?.Organization.title}
            </h5>
          </h6>
        )}
        <Divider className="col-12" />
        {state.currentPotential?.Township && (
          <h6 className="col-md-4 col-12 my-1">
            <span style={{ color: "#6c6c6c", fontSize: "15px" }}>شهرستان</span>{" "}
            <br />
            <h5 className="mt-1">{state.currentPotential?.Township.title}</h5>
          </h6>
        )}
        {state.currentPotential?.City && (
          <h6 className="col-md-4 col-12 my-1">
            <span style={{ color: "#6c6c6c", fontSize: "15px" }}>شهر</span>{" "}
            <br />
            <h5 className="mt-1">{state.currentPotential?.City.title}</h5>
          </h6>
        )}
        {state.currentPotential?.Part && (
          <h6 className="col-md-4 col-12 my-1">
            <span style={{ color: "#6c6c6c", fontSize: "15px" }}>بخش</span>{" "}
            <br />
            <h5 className="mt-1">{state.currentPotential?.Part.title}</h5>
          </h6>
        )}
        {state.currentPotential?.recommender && (
          <h6 className="col-md-4 col-12 my-1">
            <span style={{ color: "#6c6c6c", fontSize: "15px" }}>
              پیشنهاد دهنده
            </span>{" "}
            <br />
            <h5 className="mt-1">{state.currentPotential?.recommender}</h5>
          </h6>
        )}
        {state.currentPotential?.fileLink && (
          <div className="col-12 col-md-6 col-lg-4 mt-2 mb-5">
            <a className="mt-1 lh-30" href={state.currentPotential?.fileLink}>
              <span className="mx-1">توضیحات بیشتر</span>
            </a>
          </div>
        )}
        <div className="col-12 mb-2 mt-1" style={{ height: "17rem" }}>
          <MapContainer
            maxZoom={15}
            bounds={
              state.currentPotential.spanData
                ? state.currentPotential.spanData.coordinates[0].map((el) => {
                    return [el[1], el[0]];
                  })
                : [
                    state.currentPotential.marker.coordinates[1],
                    state.currentPotential.marker.coordinates[0],
                  ]
            }
          >
            {" "}
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              key={1}
            />
            {state.currentPotential?.spanData && (
              <GeoJSON data={state.currentPotential?.spanData} />
            )}
          </MapContainer>
        </div>
        <div className="col-12 my-3 d-flex justify-content-end">
          <Button
            className="w-100"
            style={{
              height: "3rem",
              borderRadius: "6px",
            }}
          >
            <a href={state.currentPotential?.link} target="_blank">
              اعلام أمادگی
            </a>
          </Button>
        </div>
      </div>
    </Modal>
  );
};
